import React from 'react'
import { SectionHeading } from '../../Headers'
import { PLL_LINKS } from '../../../Config/config'
import { ShopProduct } from '../../../Api'
import { CardSwiper } from '../../CardSwiper'
import { ShopItem } from './ShopItem'
type ProductListParams = {
  products: ShopProduct[]
  cardSize?: 'normal' | 'small'
  medium: string
  campaign: string
  listTitle?: string
}

export const ShopList: React.FC<ProductListParams> = ({
  products,
  campaign,
  medium,
  cardSize = 'normal',
  listTitle,
}) => {
  return (
    <>
      <SectionHeading
        headingText={listTitle || 'Trending In The Shop'}
        linkText={'Go To Shop'}
        linkUrl={`${PLL_LINKS.shop}?utm_source=pll_web&utm_campaign=${
          campaign ?? 'general_shop_link'
        }${medium ? `&utm_medium=${medium}` : ''}`}
      />
      <CardSwiper
        items={products.map((product) => (
          <ShopItem
            product={product}
            size={cardSize}
            campaign={campaign}
            medium={medium}
          />
        ))}
        merchCardSize={cardSize}
      />
    </>
  )
}
